// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContractCard_wrapper__ka037","legend":"ContractCard_legend__TkDyC","item":"ContractCard_item__iDlyk"};